<template>
  <div style="padding-bottom: 5em">
    <sui-segment id="footer" vertical aligned="center">
      &copy;&nbsp;
      <span>{{ $t('strCopyright') }}</span><br />
      <span>{{ $t('stringHotline') }}</span> &nbsp;|&nbsp;
      <a class="footerItem" href="/help" @click="select($event,'/help')">{{ $t('labelHelp') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" href="/contact" @click="select($event,'/contact')">{{ $t('labelContact') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" href="/imprint" @click="select($event, '/imprint')">{{ $t('labelImprint') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" href="/privacy" @click="select($event, '/privacy')">{{ $t('labelPrivacy') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" href="/conditions" @click="select($event, '/conditions')">{{ $t('labelConditions') }}</a> &nbsp;|&nbsp;
      <sui-dropdown simple :options="language" text="Language" v-model="$i18n.locale" />
    </sui-segment>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    data() {
      return {
        modalConditions: false,
        modalPrivacy: false,
        currentLanguage: 'de',
        language: [
          { key: 'gb', value: 'gb', flag: 'gb', text: 'English' },
          { key: 'de', value: 'de', flag: 'de', text: 'German' },
          { key: 'ua', value: 'ua', flag: 'ua', text: 'українська' },
          // { key: 'ru', value: 'ru', flag: 'ru', text: 'Русский' }
        ]
      }
    },
    methods: {
      select(event, target) {
        if (event) {
          event.preventDefault()
        }
        if (this.$router.currentRoute.fullPath != target) {
          this.$router.push(target);
        }
      }
    }
  }
</script>
